export default {
  title: 'Billing Unit Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Unit name, container type',
    isContainerUnit: 'Is Container Unit',
    isContainerUnitPlaceholder: 'Select type',
    status: 'Status',
    statusPlaceholder: 'Select status',
    yes: 'Yes',
    no: 'No',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addFromLibrary: 'Add Billing Unit',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enableItem: 'Enable',
    disableItem: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    unitNameCn: 'Unit Name (Chinese)',
    unitNameEn: 'Unit Name (English)',
    isContainerUnit: 'Is Container Unit',
    containerType: 'Container Type',
    status: 'Status',
    operation: 'Operation',
    notSet: 'Not Set',
    noApplicable: '-'
  },

  // Selection modal
  modal: {
    title: 'Select Billing Units',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} billing units, {total} available'
  },

  // Confirmation dialogs
  confirm: {
    enableItem: 'Are you sure to enable this billing unit?',
    disableItem: 'Are you sure to disable this billing unit?'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select billing units to enable',
    selectToDisable: 'Please select billing units to disable',
    selectToAdd: 'Please select billing units to add',
    loadError: 'Failed to load billing unit data, please try again later',
    searchError: 'Failed to search billing units, please try again later',
    platformLoadError: 'Failed to load platform billing unit data, please try again later',
    associateError: 'Failed to associate billing units, please try again later',
    associateSuccess: 'Successfully added {count} billing units',
    statusToggleError: 'Failed to toggle status, please try again later',
    statusToggleSuccess: 'Billing unit has been {status}',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchEnableSuccess: 'Enabled {count} billing units',
    batchDisableError: 'Failed to batch disable, please try again later',
    batchDisableSuccess: 'Disabled {count} billing units'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled',
    yes: 'Yes',
    no: 'No'
  }
}